"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const header_base_1 = require("./header-base");
/**
 * <SidePanel.Header>
 *
 * Блок с заголовком для SidePanel.
 */
const Header = (props) => (0, jsx_runtime_1.jsx)(header_base_1.HeaderBase, Object.assign({}, props));
exports.Header = Header;
